export default __webpack_public_path__ + "static/media/3031 cutlery top.08cee1ee.png";